module.exports = __webpack_public_path__ + "static/media/logo_login.e0cab515.png";